import { render, staticRenderFns } from "./TablePage.vue?vue&type=template&id=217f2b84&scoped=true"
import script from "./TablePage.vue?vue&type=script&lang=js"
export * from "./TablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217f2b84",
  null
  
)

export default component.exports